import React from 'react';
import Dispatcher from '../dispatcher';
import FractionStore from '../stores/fraction-store';

var Users = {

  // Call this if you want to redirect the user to complete their account
  completeAccount: function(){
    if (Fraction.User &&
        Fraction.User.ssoOnly &&
        Fraction.Router.getRoute()[0]!=="/home/eula" &&
        Fraction.Router.getRoute()[0]!=="terms" &&
        Fraction.Router.getRoute()[0]!=="user" &&
        !Fraction.Brand.AccountCompletion.ssoOnly){
      Fraction.Helpers.clearStoredBookList();
      Fraction.Helpers.storeAndRedirect('/user/sso');
    }
  },

  // Call this if you want to redirect the user to tos
  tos: function(){ // deprecated
    if (Fraction.User &&
        !Fraction.User.eulaAccepted &&
        Fraction.Router.getRoute()[0]!=="terms" && Fraction.Router.getRoute()[0]!=="user" &&
        !Fraction.Brand.AccountCompletion.skipTOS){
      Fraction.Helpers.clearStoredBookList();
      Fraction.Helpers.storeAndRedirect('/terms');
    }
  },

  // Call this if you want to redirect the user to force update their password
  resetPassword: function(){
    if (Fraction.User &&
        !Fraction.User.ssoOnly &&
        Fraction.User.needsPasswordUpdate &&
        Fraction.Router.getRoute()[0]!=="terms" &&
        Fraction.Router.getRoute()[0]!=="user" &&
        Fraction.Router.getRoute()[0]!=="/home/eula"){
      Fraction.Helpers.storeAndRedirect('/user/update-password');
    }
  },

  // Call this if you want to redirect the user to sign in
  // but have the url param be saved in a way that will
  // redirect them back to the current location after sign in.
  signin: function(){
    Fraction.Helpers.clearStoredBookList();
    if (Fraction.Router.getRoute()[0]!=="user"){
      Fraction.Helpers.storeAndRedirect('/user/signin');
    }
  },

  isStrongPassword: function(password){
    if (password.length < 4){
      return false;
    } else {
      return true;
    }
  },

  signUserOut: function(){
    Jigsaw.User.signOut(function(){
      Fraction.Helpers.clearStoredBookList();
      Fraction.Helpers.clearRedirect();
      Fraction.User = undefined;
      Fraction.Helpers.deleteDataObject('User.Persist');
      Fraction.Helpers.savePersist();
      Fraction.Helpers.loadPersist();
      const dest = Fraction.Brand.Locations.signout_redirect;
      if (Fraction.Brand.Alohomora.enabled) {
        if (Fraction.Helpers.isRelativeURL(dest)){
          window.location = `https://${Fraction.Brand.Alohomora.host}/logout?redirect_uri=${window.location.origin+dest}&brand=${window.location.hostname}`;
        } else {
          window.location = `https://${Fraction.Brand.Alohomora.host}/logout?redirect_uri=${dest}&brand=${window.location.hostname}`;
        }
      } else {
        if (Fraction.Helpers.isRelativeURL(dest)){
          Fraction.Router.setRoute(dest);
        } else {
          Fraction.Helpers.Locations.safeRedirect(dest);
        }
      }
    });
  },

  getUserEmailHash: function(){
    if (Fraction.User && Fraction.User.email){
      return "_"+Fraction.User.email.hashMe();
    }
    return "_default";
  },

  // needed an easier way to get user data
  userData: function(){
    return Fraction.Helpers.getDataObject("User.Persist");
  },

  getUserData: function(key){
    var userData = Fraction.Helpers.getDataObject("User.Persist");
    return userData[key];
  },

  // needed an easier function to save user data
  saveUserData: function(key, data, dispatch=false){
    var userData = Fraction.Helpers.getDataObject("User.Persist");
    userData[key] = data;
    Fraction.Helpers.savePersist();
    dispatch && Dispatcher.emit(Dispatcher.SAVE_USER_DATA)
  },

  setUserInfo: function(data, callback) {
    Jigsaw.User.setInfo(data, (response) => {
      if (response.isSuccess()){
        Fraction.User = response.data;
        Fraction.Helpers.setupDefaultLabs();
        Dispatcher.emit(Dispatcher.USER_CHANGE, Fraction.User);
      }
      if (callback) { callback(response); }
    });
  },

  // Get the user information and store it if need be
  getUser: function(callback, options){
    options = options || {};
    if (Fraction.User && !options.refresh){
      callback();
      Fraction.setupContext(Fraction.User);
    } else {
      Jigsaw.User.getInfo(function(response){
        if (response.isSuccess()){
          Fraction.User = response.data.user;
          Fraction.Helpers.loadPersist();
          // Check if session ID matches old session ID.  If not, increment log counter
          Fraction.Helpers.initNPSFeedback();
          var obj = Fraction.Helpers.getDataObject("User.Persist");
          if (!obj['allow-cookies']) {
            const defaultEmailData = JSON.parse(Fraction.Helpers.getItem('_default_fraction_data'));
            Fraction.Helpers.Users.saveUserData('allow-cookies', !!defaultEmailData && defaultEmailData['allow-cookies']);
            Fraction.Helpers.Users.saveUserData('analytics-cookies', !!defaultEmailData && defaultEmailData['analytics-cookies']);
          }
          var suffix = "-" + Fraction.User.email.hashMe().toString();
          if (Fraction.User && Fraction.User.sessionId !== obj["NPSLog" + suffix]["previous-session"]) {
            // Increment logins number, only if it's already set to a valid integer
            obj["NPSLog" + suffix].logins = (parseInt(obj["NPSLog" + suffix].logins, 10) || 0) + 1;
          }
          // Save new session
          obj["NPSLog" + suffix]["previous-session"] = Fraction.User.sessionId;

          Fraction.Helpers.setupDefaultLabs();
          Fraction.Helpers.savePersist();

          Fraction.Helpers.changeLocale(Fraction.User.locale, callback);

          Dispatcher.emit(Dispatcher.USER_CHANGE, Fraction.User);

          Fraction.setupContext(Fraction.User);
        } else {
          // If get user errors out, check if third party cookies are disabled,
          // and if so redirect to appropriate error page
          if (response.data.errors && response.data.errors.message === "You must enable third-party cookies") {
            Fraction.Router.setRoute("cookie-error");
            if (callback){ callback(); }
          } else if (!options.skipAuth){
            Fraction.Helpers.signin();
          } else {
            callback();
          }
          Fraction.setupContext({});
        }
      });
    }
  },

  userUpdateLicense: function(options){
    options = options || {};
    if (!FractionStore.get()["license-updating"]){
      Fraction.Helpers.Users.getUser(function(){
        Fraction.Helpers.clearStoredBookList();
        if (!options.noToast){
          Fraction.Helpers.toast(i18n.t('library.license-updating'));
        }
        if (options.auto){
          if (Fraction.User){ Fraction.User.needsBookListUpdate = false; }
          var obj = Fraction.Helpers.deleteDataObject("Library.BookList");
          delete obj.books;
          Dispatcher.emit(Dispatcher.LIBRARY_UPDATED);
        }
        Dispatcher.emit(Dispatcher.LICENSE_UPDATING, options);
        if (Fraction.Brand.Library.asyncLicense) {
          const checkLicenseStatus = (id) => {
            Jigsaw.User.asyncLicenseStatus(id, (r) => {
              const { message } = r.data;
              if (message === 'finished' || !message) {
                Dispatcher.emit(Dispatcher.LICENSE_UPDATED, options);
              } else {
                setTimeout(() => {
                  checkLicenseStatus(id);
                }, 3000);
              }
            });
          };
          Jigsaw.User.asyncUpdateLicense((r) => {
            checkLicenseStatus(r.data.id); // I *think* that's the attr
          });
        } else {
          Jigsaw.User.updateLicense(function(response){
            Fraction.Helpers.Users.getUser(function(){
              Dispatcher.emit(Dispatcher.LICENSE_UPDATED, options);
            }, {refresh: true});
            if (!response.isSuccess()){
              Fraction.Helpers.Locations.systemError(response.data.code);
              Fraction.Helpers.removeLoader('#bookshelf');
              Fraction.Helpers.removeLoader('header');
            }
          });
        }
      });
    }
  },

  isValidPassword: function(password){
    return !(password.length < 8 ||
             !(password.match(/[A-Z]/) &&
               password.match(/[a-z]/) &&
               password.match(/[~\!@#\$%\^&*\(\)_\-\+=\|\}\]\{\[:;"',\.\?\/<>\`\\]/)
            ));
  },

  isReferenceUser() {
    return Fraction.User.ssoOnly;
  },

  isFullAccountUser() {
    return !Fraction.Brand.AccountCompletion.ssoOnly && Fraction.User && !Fraction.User.ssoOnly;
  },

  isLearner() {
    return Fraction.User && Fraction.User.roles && Fraction.User.roles.some(role => role.name === "learner");
  },

  isInstructor() {
    return Fraction.User && Fraction.User.roles && Fraction.User.roles.some(role => role.name === "instructor");
  },

  // load recaptcha only if necessary
  loadRecaptchaScript() {
    const locale = i18n.getCurrentLocale();
    const src = `https://www.recaptcha.net/recaptcha/api.js?onload=recaptchaLoadCallback&render=explicit&hl=${locale}`;

    const head = document.getElementsByTagName("head")[0];
    const oldScript = document.getElementById('recaptcha-script');

    // If recaptcha has already been loaded, but the language has changed, we want to remove
    // the old script tag and replace it with a new one.
    // NOTE: you'll also need to remove the dom element that recaptcha has loaded into
    if (oldScript) {
      if (oldScript.src === src) {
        return;
      }
      head.removeChild(oldScript);
    }

    var script = document.createElement("script");
    script.src = src;
    script.type = "text/javascript";
    script.id = 'recaptcha-script';

    head.appendChild(script);

    Fraction.Helpers.addLoader("#signin-form");
  }

};

module.exports = Users;
